// extracted by mini-css-extract-plugin
export default {"row":"style_row__vggiX","badge":"style_badge__27hyU"};